import { render, staticRenderFns } from "./EditClienteSolcitudInfo.vue?vue&type=template&id=4c021e1c&scoped=true&"
import script from "./EditClienteSolcitudInfo.vue?vue&type=script&lang=js&"
export * from "./EditClienteSolcitudInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditClienteSolcitudInfo.vue?vue&type=style&index=0&id=4c021e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c021e1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VTextField})
